// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorProductCategories = (client) => ({
    /**
     * `GET /vendor/product-categories`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProductCategories
     * @source packages/modules/b2c-core/src/api/vendor/product-categories/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/product-categories", { method: "GET", query, headers }),
    /**
     * `GET /vendor/product-categories/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductCategoriesIdProductsRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/product-categories/[id]/products/route.ts
     */
    listProducts: (id, query, headers) => client.fetch(buildPath("/vendor/product-categories/:id/products", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/product-categories/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductCategoryById
     * @source packages/modules/b2c-core/src/api/vendor/product-categories/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/product-categories/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=product-categories.js.map